/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_BannerInputs */

const en_offline_banner = /** @type {(inputs: Offline_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're offline. Recipes on this device still work; imports and editing need a connection.`)
};

const de_offline_banner = /** @type {(inputs: Offline_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist offline. Die Rezepte auf diesem Gerät funktionieren weiter; Importe und Bearbeiten brauchen eine Verbindung.`)
};

/**
* | output |
* | --- |
* | "You're offline. Recipes on this device still work; imports and editing need a connection." |
*
* @param {Offline_BannerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const offline_banner = /** @type {((inputs?: Offline_BannerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_BannerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_offline_banner(inputs)
	return en_offline_banner(inputs)
});